import http from '~/http/index';

export default ({
  state: {
    data: [
      { id: 1, name: 'Undefined', value: 1 },
      { id: 2, name: 'Other', value: 1 },
      { id: 3, name: 'Miner', value: 2 },
      { id: 4, name: 'Wallet', value: 3 },
      { id: 5, name: 'Exchange', value: 50 },
    ],
  },

  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    async loadData({ commit }) {
      const response = await http.get('api/riskCategories');
      commit('SET_DATA', response.data);
    },

    async editRisks(__store, data) {
      const response = await http.put('api/riskCategories', {
        adminId: data.adminId,
        riskCategories: data.riskCategories,
      });
      return response.data;
    },
  },

  namespaced: true,
});
